export const RESUME = 'https://docs.google.com/document/d/1O0ZLR9MmxdTYacFWWW0EQ_H3sa1TQi7GN5KH_-SX7_8/edit?tab=t.0';